<template>
  <b-container
    fluid
    class="p-0 web-header d-flex flex-column"
    :class="showHanderBgImg ? '' : 'bg-white'"
    :style="showHanderBgImg ? `background-image:url(${handerBgImg});background-size: 100% 100%;background-repeat: no-repeat;height:${handerHeight};justify-content:center;` : `height:${handerHeight};justify-content:center;`"
  >
    <b-container
      class=""
      style=""
    >
      <b-navbar toggleable="lg">
        <!-- Logo区域 - 移动端和桌面端都显示 -->
        <b-navbar-brand
          href="/"
          class="d-flex align-items-center"
        >
          <b-img
            left
            v-if="logos.length > 0"
            :src="logos[0].url"
            fluid
            class="logo mobile-logo"
            alt="logo"
          ></b-img>
        </b-navbar-brand>

        <!-- 网站名称 - 在移动端隐藏或简化显示 -->
        <b-navbar-brand
          class="d-none d-md-block"
          v-if="logos.length > 1 || (loadConfig && loadConfig.ws_name)"
          style="min-width:8rem;"
        >
          <b-img
            left
            v-if="logos.length > 1"
            :src="logos[1].url"
            fluid-grow
            class="logo"
            alt="logo"
            style="height: auto;"
          ></b-img>
          <div
            v-if="loadConfig && loadConfig.ws_name"
            class="logo"
            style="height: auto;"
          >
            <div class="web-name">{{ loadConfig.ws_name }}
            </div>
            <div
              class="text-listTitleColor web-name-sub"
              v-if="loadConfig && loadConfig.en_name"
            >{{ loadConfig.en_name }}
            </div>
          </div>
        </b-navbar-brand>

        <!-- 移动端汉堡菜单按钮 -->
        <b-navbar-toggle
          target="mobile-nav-collapse"
          class="d-lg-none mobile-menu-toggle"
        >
          <template #default="{ expanded }">
            <span class="navbar-toggler-icon-custom">
              <span
                class="bar"
                :class="{ 'bar-1-active': expanded }"
              ></span>
              <span
                class="bar"
                :class="{ 'bar-2-active': expanded }"
              ></span>
              <span
                class="bar"
                :class="{ 'bar-3-active': expanded }"
              ></span>
            </span>
          </template>
        </b-navbar-toggle>

        <!-- 桌面端导航菜单 -->
        <b-navbar-nav
          class="ml-md-auto d-none d-lg-flex flex-row justify-content-end"
          v-if="login.show || search.show || !login.show"
        >
          <b-nav-item
            right
            v-if="search.show"
          >
            <b-nav-form>
              <b-form-input
                size="sm"
                class="desktop-search"
                style="width: auto;"
                placeholder="搜索"
                v-model="searchVal"
              ></b-form-input>
              <b-button
                size="sm"
                class="my-2 my-sm-0"
                variant="primary"
                icon="bi bi-search"
                :to="`/search?str=${searchVal}`"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-search"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
                  />
                </svg>
              </b-button>
            </b-nav-form>
          </b-nav-item>
          <b-nav-item
            right
            v-if="login.show"
          >
            <b-nav-form>
              <b-button
                size="sm"
                class="my-2 my-sm-0"
                type="submit"
                variant="orange"
                to="/"
              >跳转</b-button>
              <template>
                <span
                  @click="toMember()"
                  class="mr-1"
                  v-if="loginInfo.isLogin && loginInfo.info"
                >
                  欢迎：[{{ loginInfo.isLogin && loginInfo.info ? loginInfo.info.real_name : '未登录' }}]
                </span>
                <b-dropdown
                  v-if="loginInfo.isLogin && loginInfo.info"
                  right
                  id="user-set"
                  text="会员中心"
                  class="p-0"
                  size="sm"
                  variant="outline-orange"
                >
                  <b-dropdown-item @click="toMember()">会员中心</b-dropdown-item>
                  <b-dropdown-item to="/resetpwd">修改密码</b-dropdown-item>
                  <b-dropdown-item @click="showModal">退出登录</b-dropdown-item>
                </b-dropdown>
              </template>
            </b-nav-form>
          </b-nav-item>
          <b-nav-item
            right
            v-if="links && Array.isArray(links) && links.length > 0"
            class="web-hander-link"
          >
            <b-nav-form>
              <b-button
                class="my-2 my-sm-0 mr-3"
                type="submit"
                variant="web-style-lighten"
                @click="onLink(link)"
                v-for="(link, index) in links"
                :key="index"
              >
                <b-img
                  v-if="index == 0"
                  v-bind="{ width: 22, height: 22 }"
                  :src="handerLinkIcon.left"
                  rounded
                  alt="Rounded image"
                ></b-img>
                <b-img
                  v-if="index == 1"
                  v-bind="{ width: 22, height: 22 }"
                  :src="handerLinkIcon.right"
                  rounded
                  alt="Rounded image"
                ></b-img>
                <span class="text-listTitleColor pl-2 font-weight-bold">{{ link.text }}</span>
              </b-button>
            </b-nav-form>
          </b-nav-item>
        </b-navbar-nav>

        <!-- 移动端折叠菜单 -->
        <b-collapse
          id="mobile-nav-collapse"
          is-nav
          class="d-lg-none mobile-nav-menu"
        >
          <b-navbar-nav class="mobile-nav-items">
            <!-- 移动端搜索 -->
            <b-nav-item
              v-if="search.show"
              class="mobile-search-item"
            >
              <b-nav-form class="mobile-search-form">
                <div class="mobile-search-wrapper">
                  <b-form-input
                    size="sm"
                    class="mobile-search-input"
                    placeholder="搜索"
                    v-model="searchVal"
                  ></b-form-input>
                  <b-button
                    size="sm"
                    variant="primary"
                    class="mobile-search-btn"
                    :to="`/search?str=${searchVal}`"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-search"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
                      />
                    </svg>
                  </b-button>
                </div>
              </b-nav-form>
            </b-nav-item>

            <!-- 移动端用户菜单 -->
            <b-nav-item
              v-if="login.show"
              class="mobile-user-item"
            >
              <div class="mobile-user-section">
                <b-button
                  size="sm"
                  variant="orange"
                  to="/"
                  class="mobile-jump-btn"
                >跳转</b-button>
                <div
                  v-if="loginInfo.isLogin && loginInfo.info"
                  class="mobile-user-info"
                >
                  <div
                    class="mobile-welcome-text"
                    @click="toMember()"
                  >
                    欢迎：{{ loginInfo.info.real_name }}
                  </div>
                  <div class="mobile-user-actions">
                    <b-button
                      size="sm"
                      variant="outline-primary"
                      @click="toMember()"
                      class="mobile-action-btn"
                    >会员中心</b-button>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      to="/resetpwd"
                      class="mobile-action-btn"
                    >修改密码</b-button>
                    <b-button
                      size="sm"
                      variant="outline-danger"
                      @click="showModal"
                      class="mobile-action-btn"
                    >退出登录</b-button>
                  </div>
                </div>
              </div>
            </b-nav-item>

            <!-- 移动端链接 -->
            <b-nav-item
              v-if="links && Array.isArray(links) && links.length > 0"
              class="mobile-links-item"
            >
              <div class="mobile-links-section">
                <b-button
                  class="mobile-link-btn"
                  variant="web-style-lighten"
                  @click="onLink(link)"
                  v-for="(link, index) in links"
                  :key="index"
                >
                  <b-img
                    v-if="index == 0"
                    v-bind="{ width: 20, height: 20 }"
                    :src="handerLinkIcon.left"
                    rounded
                    alt="Rounded image"
                  ></b-img>
                  <b-img
                    v-if="index == 1"
                    v-bind="{ width: 20, height: 20 }"
                    :src="handerLinkIcon.right"
                    rounded
                    alt="Rounded image"
                  ></b-img>
                  <span class="text-listTitleColor pl-2">{{ link.text }}</span>
                </b-button>
              </div>
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </b-container>
  </b-container>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
// 移动端Logo优化
.mobile-logo {
  max-height: 40px;
  width: auto;
}

// 汉堡菜单按钮样式
.mobile-menu-toggle {
  border: none;
  background: transparent;
  padding: 4px;

  .navbar-toggler-icon-custom {
    display: flex;
    flex-direction: column;
    width: 24px;
    height: 18px;
    justify-content: space-between;

    .bar {
      height: 3px;
      width: 100%;
      background-color: #333;
      border-radius: 2px;
      transition: all 0.3s ease;
      transform-origin: center;
    }

    .bar-1-active {
      transform: rotate(45deg) translate(5px, 5px);
    }

    .bar-2-active {
      opacity: 0;
    }

    .bar-3-active {
      transform: rotate(-45deg) translate(6px, -6px);
    }
  }
}

// 移动端导航菜单样式
.mobile-nav-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border-top: 1px solid #e9ecef;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;

  .mobile-nav-items {
    flex-direction: column;
    width: 100%;
    padding: 1rem 0;
  }
}

// 移动端搜索样式
.mobile-search-item {
  padding: 0.5rem 1rem;
  border-bottom: 1px solid #f8f9fa;

  .mobile-search-form {
    width: 100%;

    .mobile-search-wrapper {
      display: flex;
      gap: 0.5rem;
      align-items: center;

      .mobile-search-input {
        flex: 1;
        min-height: 44px; // 移动端友好的触摸目标
      }

      .mobile-search-btn {
        min-height: 44px;
        min-width: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

// 移动端用户菜单样式
.mobile-user-item {
  padding: 0.5rem 1rem;
  border-bottom: 1px solid #f8f9fa;

  .mobile-user-section {
    .mobile-jump-btn {
      width: 100%;
      min-height: 44px;
      margin-bottom: 0.5rem;
    }

    .mobile-user-info {
      .mobile-welcome-text {
        padding: 0.75rem 0;
        font-weight: 500;
        color: #495057;
        cursor: pointer;
        border-bottom: 1px solid #f8f9fa;
        margin-bottom: 0.5rem;

        &:hover {
          color: #007bff;
        }
      }

      .mobile-user-actions {
        display: flex;
        flex-direction: column;
        gap: 0.5rem;

        .mobile-action-btn {
          width: 100%;
          min-height: 44px;
          text-align: left;
          justify-content: flex-start;
        }
      }
    }
  }
}

// 移动端链接样式
.mobile-links-item {
  padding: 0.5rem 1rem;

  .mobile-links-section {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    .mobile-link-btn {
      width: 100%;
      min-height: 44px;
      text-align: left;
      justify-content: flex-start;

      .text-listTitleColor {
        font-size: 0.9rem;
      }
    }
  }
}

// 桌面端搜索优化
.desktop-search {
  min-width: 200px;
}

// 响应式断点优化
@media (max-width: 991.98px) {
  .web-header {
    .navbar {
      padding: 0.5rem 0;
    }

    .navbar-brand {
      font-size: 1.1rem;
    }
  }
}

@media (max-width: 767.98px) {
  .web-header {
    height: 60px !important;

    .navbar-brand {
      font-size: 1rem;

      .mobile-logo {
        max-height: 35px;
      }
    }
  }
}

@media (max-width: 575.98px) {
  .mobile-nav-menu {

    .mobile-search-item,
    .mobile-user-item,
    .mobile-links-item {
      padding: 0.75rem 1rem;
    }

    .mobile-search-wrapper {

      .mobile-search-input,
      .mobile-search-btn {
        min-height: 48px; // 更大的触摸目标
      }
    }

    .mobile-user-section {

      .mobile-jump-btn,
      .mobile-action-btn {
        min-height: 48px;
      }
    }

    .mobile-links-section {
      .mobile-link-btn {
        min-height: 48px;
      }
    }
  }
}
.collapse:not(.show) {
  display: none !important;
}
</style>

<script>
//   import zhuanxian from '@/assets/zhuanxian.png'
import zhuanxian from '@/assets/handerbg.png'
// import llink from '@/assets/index/llink.png'
import llink from '@/assets/index/bluelink.png'
import rlink from '@/assets/index/rlink.png'
import store from '@/store'
import { loginOut } from '@/api/api.js'
export default {
  name: 'SiteHeader',
  components: {

  },
  props: {

  },
  mounted() {
    this.getLogos()
  },
  computed: {
    showHanderBgImg() {
      let show = this.webConfig.hander.showBgImg || false

      return show
    },
    handerHeight() {
      let height = this.webConfig.hander.height || '80px'

      return height
    },
    loginInfo() {
      let state = {
        isLogin: false,
        info: null
      }
      if (store.getters.getLoginInfo) {
        state = {
          isLogin: store.getters.getLoginState,
          info: store.getters.getLoginInfo,
        }
      }


      return state
    },
    login() {
      let config = this.webConfig.hander.login || { show: false, text: '登录' }
      config.show = store.getters.getOnLogin
      return config
    },
    links() {
      let handerLinks = null
      handerLinks = this.webConfig.hander.links

      return handerLinks
    },
    search() {
      let config = this.webConfig.hander.search || {
        text: '搜索',
        icon: "",
        show: true
      }
      config.show = store.getters.getOnSearch
      return config
    },
    loadConfig() {
      let config = store.getters.getWebConfig

      return config
    },


  },
  data() {
    return {
      handerBgImg: zhuanxian,
      searchVal: '',
      logos: [],
      modalShow: false,
      handerLinkIcon: {
        left: llink,
        right: rlink
      }
    }
  },
  methods: {
    onLink(link) {
      if (link.href?.indexOf('http') > -1) {
        window.open(link.href, link.target)
      } else {
        this.$router.push({ path: link.href })
      }
    },
    toLogin(path) {
      this.$router.push({ path: path })
    },
    toMember() {
      this.toMemberCenter()
    },
    getLogos() {
      let info = store.getters.getWebConfig
      let logos = []
      if (info.logo) {
        // logos =
        this.getFileUrls(info.logo).then(res => {
          // console.log('get logos ',res)
          if (Array.isArray(res)) {
            logos = res.map(item => {
              let obj = {
                url: `${store.getters.hostPath}/file/download?filePath=${item.fileurl}`,
                '_data': item
              }
              return obj

            })
            this.logos = logos.map(item => item)
          }

        })
        // console.log('logo',logos)
      }
    },
    showModal() {
      // this.$bvModal.show('logout')
      let self = this
      console.log(this)
      this.$bvModal.msgBoxConfirm('确认退出当前登录.', {
        title: '请确认',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'primary',
        okTitle: '退出',
        cancelTitle: '取消',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          console.log(value)
          if (value == true) {
            loginOut().then(res => {
              console.log(res)
              if (res.state == 'SUCCESS') {

                store.dispatch('closelogin')
                if (self.$route.fullPath !== '/') {

                  self.$router.replace({ path: '/' })
                }
              }
            })
          }
        })
        .catch(err => {
          // An error occurred
        })
    },
    hideModal() {
      this.$bvModal.hide('logout')
      // this.$refs['logout'].hide()
    },
    goLogout() {
      store.dispatch('closelogin')
    }
  },
  watch: {
  }
}
</script>